import styled from 'styled-components';
import { OBreadcrumbType } from './OBreadcrumb.types';

const dividerOffset = (type: OBreadcrumbType) => {
  switch (type) {
    case OBreadcrumbType.TopBorder:
      return 'top: 0;';
    case OBreadcrumbType.BottomBorder:
      return 'bottom: 0;';
    default:
      return '';
  }
};

export const OBreadcrumbWrapper = styled.div<{ type: OBreadcrumbType }>`
  width: 100%;
  padding: 16px 0;
  position: relative;

  > hr {
    position: absolute;
    ${({ type }) => dividerOffset(type)}
  }
`;

export const OBreadcrumbContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
